import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { StaticContentComponent } from './static-content.component';
import { AEMRoutes } from '../../core/constants/routes.constant';
import { AuthGuard } from '../../core/guards/auth.guard';
import { DesktopDeviceGuard } from '../../core/guards/desktop-device.guard';
import { MobileComponent } from './mobile/mobile.component';
import { MobileDeviceGuard } from '../../core/guards/mobile-device.guard';
import { ProductCatlogComponent } from './product-catlog/product-catlog.component';
import { ProductCatalogListComponent } from '../products/product-catalog-list/product-catalog-list.component';
import { ProductRouteParams } from '../../core/constants/route-params.constant';

const routes: Routes = [
  {
    path: AEMRoutes.Shop,
    component: StaticContentComponent,
    data: {
      aemUrl: '/content/parmed/shop/shop.html'
    },
    canActivate: [AuthGuard, DesktopDeviceGuard]
  },
  // {
  //   path: AEMRoutes.AboutUs,
  //   component: StaticContentComponent,
  //   data: {
  //     aemUrl: '/content/parmed/aboutus.html'
  //   },
  //   canActivate: [DesktopDeviceGuard]
  // },
  {
    path: AEMRoutes.MyAccount,
    component: StaticContentComponent,
    data: {
      aemUrl: '/content/parmed/shop/myaccount.html'
    },
    canActivate: [AuthGuard, DesktopDeviceGuard]
  },
  {
    path: AEMRoutes.MyAccountHarvard,
    component: StaticContentComponent,
    data: {
      aemUrl: '/content/parmed/shop/myaccountharvard.html'
    },
    canActivate: [AuthGuard, DesktopDeviceGuard]
  },
  {
    path: AEMRoutes.Help,
    component: StaticContentComponent,
    data: { aemUrl: '/content/parmed/Help.html' },
    canActivate: [DesktopDeviceGuard]
  },
  {
    path: AEMRoutes.ProductServices,
    component: StaticContentComponent,
    data: {
      aemUrl: '/content/parmed/productsandservices.html'
    },
    canActivate: [DesktopDeviceGuard]
  },
  {
    path: AEMRoutes.MajorProductServices,
    component: StaticContentComponent,
    data: {
      aemUrl: '/assets/static-content/majorProductAndServices.html'
    },
    canActivate: [DesktopDeviceGuard]
  },
  {
    path: AEMRoutes.Legal,
    component: StaticContentComponent,
    data: { aemUrl: '/content/parmed/legal.html' },
    canActivate: [DesktopDeviceGuard]
  },
  {
    path: AEMRoutes.Privacy,
    component: StaticContentComponent,
    data: {
      aemUrl: '/content/parmed/privacy.html'
    },
    canActivate: [DesktopDeviceGuard]
  },
  {
    path: AEMRoutes.Employment,
    component: StaticContentComponent,
    data: {
      aemUrl: '/content/parmed/employment.html'
    },
    canActivate: [DesktopDeviceGuard]
  },
  {
    path: AEMRoutes.ReturnConfirmation,
    component: StaticContentComponent,
    data: {
      aemUrl: '/content/parmed/shop/returnconfirmation.html'
    },
    canActivate: [DesktopDeviceGuard]
  },
  {
    path: AEMRoutes.ReturnLanding,
    component: StaticContentComponent,
    data: {
      aemUrl: '/content/parmed/shop/returns.html'
    },
    canActivate: [AuthGuard, DesktopDeviceGuard]
  },
  {
    path: AEMRoutes.SDS,
    component: StaticContentComponent,
    data: {
      aemUrl: '/content/parmed/sds.html'
    },
    canActivate: [DesktopDeviceGuard]
  },
  {
    path: AEMRoutes.EMED_BINAX_NOW,
    component: StaticContentComponent,
    data: {
      aemUrl: '/content/parmed/emedbinaxNOW.html'
    },
    canActivate: [DesktopDeviceGuard]
  },
  {
    path: AEMRoutes.CSOSHelp,
    component: StaticContentComponent,
    data: {
      aemUrl: '/content/parmed/shop/CSOSHelp.html'
    },
    canActivate: [AuthGuard, DesktopDeviceGuard]
  },
  {
    path: AEMRoutes.SubscriptionsHelp,
    component: StaticContentComponent,
    data: {
      aemUrl: '/content/parmed/subscriptionsHelp.html'
    },
    canActivate: [AuthGuard, DesktopDeviceGuard]
  },
  {
    path: AEMRoutes.Major.Welcome,
    component: StaticContentComponent,
    data: {
      aemUrl: '/assets/static-content/welcome.html'
    },
    // canActivate: [DesktopDeviceGuard]
  },
  {
    path: AEMRoutes.Major.NewAccount,
    component: StaticContentComponent,
    data: {
      aemUrl: '/assets/static-content/newaccounts.html'
    },
    // canActivate: [DesktopDeviceGuard]
  },
  {
    path: AEMRoutes.Major.News,
    component: StaticContentComponent,
    data: {
      aemUrl: '/assets/static-content/majorNews.html'
    },
    canActivate: []
  },
  {
    path: AEMRoutes.Major.Help,
    component: StaticContentComponent,
    data: {
      aemUrl: '/assets/static-content/majorHelp.html'
    },
    canActivate: [DesktopDeviceGuard]
  },
  {
    path: AEMRoutes.Parmed.Welcome,
    component: StaticContentComponent,
    data: {
      aemUrl: '/content/parmed/welcome.html'
    },
    // canActivate: [DesktopDeviceGuard]
  },
  {
    path: AEMRoutes.Parmed.NewAccount,
    component: StaticContentComponent,
    data: {
      aemUrl: '/content/parmed/newaccounts.html'
    },
    // canActivate: [DesktopDeviceGuard]
  },
  {
    path: AEMRoutes.CustomerForms,
    component: StaticContentComponent,
    data: {
      aemUrl: '/content/parmed/customerforms.html'
    },
    canActivate: [DesktopDeviceGuard]
  },
  {
    path: AEMRoutes.Major.AboutUs,
    component: StaticContentComponent,
    data: {
      aemUrl: '/assets/static-content/aboutus.html'
    },
    canActivate: []
  },
  {
    path: AEMRoutes.Major.ProductCatlog,
    component: ProductCatlogComponent,
    canActivate: []
  },
  {
    path: AEMRoutes.Parmed.AboutUs,
    component: StaticContentComponent,
    data: {
      aemUrl: '/content/parmed/aboutus.html'
    },
    canActivate: [DesktopDeviceGuard]
  },
  {
    path: AEMRoutes.DSCSA,
    component: StaticContentComponent,
    data: {
      aemUrl: '/content/parmed/dscsa.html'
    },
    canActivate: [AuthGuard, DesktopDeviceGuard]
  },
  {
    path: AEMRoutes.Mobile.Legal,
    component: MobileComponent,
    canActivate: [MobileDeviceGuard]
  },
  {
    path: AEMRoutes.Mobile.MajorLegal,
    component: MobileComponent,
    canActivate: [MobileDeviceGuard]
  },
  {
    path: AEMRoutes.Mobile.Privacy,
    component: MobileComponent,
    canActivate: [MobileDeviceGuard]
  },
  {
    path: AEMRoutes.Mobile.MajorPrivacy,
    component: MobileComponent,
    canActivate: [MobileDeviceGuard]
  },
  {
    path: AEMRoutes.MajorLegal,
    component: StaticContentComponent,
    data: {
      aemUrl: '/assets/static-content/majorlegal.html'
    },
    canActivate: [DesktopDeviceGuard]
  },
  {
    path: AEMRoutes.MajorPrivacy,
    component: StaticContentComponent,
    data: {
      aemUrl: '/assets/static-content/majorPrivacy.html'
    },
    canActivate: [DesktopDeviceGuard]
  },
  {
    path: AEMRoutes.Major.ProductCatalogList,
    component: ProductCatalogListComponent,
    // canActivate: [DesktopDeviceGuard]

  },
  {
    path: AEMRoutes.Major.ProductCatalogList+'/:' + ProductRouteParams.SearchValue,
    component: ProductCatalogListComponent,
    // canActivate: [DesktopDeviceGuard]

  },
  { path: '', redirectTo: '/home', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class StaticContentRoutingModule {}
